//
//
//
//
//
//
//
//
//
//

export default {
  props: ['open'],

  methods: {
    close() {
      window.PubSub.publish('overlay:click');
    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Overlay.vue